import { render } from "./MyBox.vue?vue&type=template&id=fb7aff40&scoped=true"
import script from "./MyBox.vue?vue&type=script&lang=js"
export * from "./MyBox.vue?vue&type=script&lang=js"

import "./MyBox.vue?vue&type=style&index=0&id=fb7aff40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb7aff40"]])

export default __exports__